"use client";
import { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ProfilePage from "@/components/ProfilePage";

import { I18N_NAMESPACE } from "@/config/i18n";
import { getDepositMethodsRequest } from "@/fe-core/_redux/actions/userActions";
import { openProcessDepositModal } from "@/fe-core/_redux/actions/userActions/cashierActions/processDepositActions";
import {
  depositMethodsSelector,
  pendingMethodsSelector,
  userBalanceDataSelector,
} from "@/fe-core/_redux/selectors/userSelectors";
import { depositPaymentMethodTypes } from "@/fe-core/meta/types/user/cashier/processDeposit";
import { useFormatter, useTranslations } from "next-intl";
import ProcessDepositModal from "@/components/Deposit/ProcessDepositModal";
import SVGIcon from "@/components/SVGIcon";
import { parsedAmount } from "@/fe-core/helpers/general";
import { paymentsSelector } from "@/fe-core/_redux/selectors/footerSelectors";
import { Link } from "../../../../../navigation";
import useTracking from "@/components/Hooks/useTracking";

const DepositMoneyComponent = (): ReactNode => {
  const isModal = false;
  const { navigate } = useTracking();
  const profileT = useTranslations(I18N_NAMESPACE.PROFILE);
  const generalT = useTranslations(I18N_NAMESPACE.GENERAL);
  const { totalCurrency: currency } =
    useSelector(userBalanceDataSelector) || {};
  const format = useFormatter();
  const dispatch = useDispatch();
  const depositMethods = useSelector(depositMethodsSelector);
  const isPendingDepositMethods = useSelector(pendingMethodsSelector);
  const paymentsData = useSelector(paymentsSelector);

  useEffect(() => {
    dispatch(getDepositMethodsRequest());
    processDeposit(depositPaymentMethodTypes.PRAXIS_ALL);
  }, [dispatch]);

  const processDeposit = (paymentMethod: depositPaymentMethodTypes) => {
    dispatch(openProcessDepositModal(paymentMethod));
  };
  // return (
  //   <ProfilePage
  //     backButton={{
  //       href: "/profile/transactions",
  //       text: `${profileT("transactions")} - ${profileT("deposit")}`,
  //     }}
  //   >
  //     <div className={`container`}>
  //       <h3 className="mb-4 font-bold text-xl text-white/70">
  //         {generalT("deposit")}
  //       </h3>
  //       <div
  //         className={`flex gap-3 items-center justify-center  bg-white rounded dark:bg-tertiary-700 min-h-[500px] `}
  //       >
  //         <div className="text-center  ">
  //           <h4 className="text-xl font-bold mb-4">
  //             {profileT("coming-soon")}
  //           </h4>
  //           <p>{profileT("coming-description")}</p>
  //         </div>
  //       </div>
  //     </div>
  //   </ProfilePage>
  // );

  return (
    <ProfilePage
      backButton={{
        href: "/profile/transactions",
        text: `${profileT("transactions")} - ${profileT("deposit")}`,
      }}
    >
      <div className={`${!isModal ? "container" : ""}`}>
        {!isModal && (
          <h3 className="mb-4 font-bold text-xl text-white/70">
            {generalT("deposit")}
          </h3>
        )}
        <div
          className={`flex flex-col gap-3  bg-white rounded dark:bg-tertiary-700 ${
            !isModal ? "p-4" : ""
          }`}
        >
          {/* {isPendingDepositMethods && (
            <div className="pt-3 pl-3">
              <span className="text-white animate-pulse">Loading...</span>
            </div>
          )} */}
          {/* <div className="grid grid-cols-2 md:grid-cols-3 gap-4 ">
            {depositMethods?.map((method, index) => {
              return (
                <div
                  key={`method__${index}`}
                  onClick={() => {
                    if (method?.conversionRequired) {
                    } else {
                      processDeposit(method?.paymentMethod);
                    }
                  }}
                  className={`flex flex-col justify-center items-center p-4 rounded bg-tertiary-600 cursor-pointer hover:scale-105 transform transition-all`}
                >
                  <div className="flex items-center justify-center p-2 ">
                    <SVGIcon
                      icon="spinner"
                      className={`w-6 h-6 text-brand-400`}
                    />
                  </div>
                  <div className=" ">
                    <p className="font-bold text-white">{method?.method}</p>
                    <p className=" text-xs ">
                      {"Min "}
                      {format.number(parsedAmount(method?.minimumDeposit), {
                        style: "currency",
                        currency,
                      })}{" "}
                      -{" "}
                      {format.number(parsedAmount(method?.maximumDeposit), {
                        style: "currency",
                        currency,
                      })}
                    </p>
                  </div>
                </div>
              );
            })}
          </div> */}

          <ProcessDepositModal />

          {paymentsData && paymentsData?.length > 0 && (
            <div className="flex flex-wrap items-center gap-3.5 lg:!gap-4 mt-5 gap-y-2">
              {paymentsData?.map((item, index) => {
                return (
                  <Link
                    href={item?.link ?? "#"}
                    target={item?.target}
                    key={`seals_${index}`}
                    onClick={() => {
                      navigate(`${item?.link ?? "#"}`, {
                        component: "FooterPayments",
                        label:
                          item?.name ||
                          item.icons?.data?.attributes?.alternativeText ||
                          item?.link,
                        navigateFrom: "Footer Links",
                      });
                    }}
                    className={`md:w-auto rounded p-3 ${
                      !item?.link ? "pointer-events-none" : ""
                    }`}
                  >
                    {item?.icons?.data?.attributes?.url && (
                      <img
                        src={`${process.env.NEXT_PUBLIC_CMS_URL}${item?.icons?.data?.attributes?.url}`}
                        className="!relative mx-auto   max-h-[30px]"
                        alt={
                          item.icons?.data?.attributes?.alternativeText ||
                          item?.name
                        }
                      />
                    )}
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </ProfilePage>
  );
};

export default DepositMoneyComponent;
